import circles from 'assets/images/circles.png';
import dialogIcon from 'assets/images/dialogLogo.svg';
import welcomeImg from 'assets/images/welcomeImg.svg';
import { Button, Input } from 'components/atoms';
import { useCheckUser } from 'framework/api/methods';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const Login = () => {
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isInputValid, setInputValid] = useState(false);

  const { mutate: checkUserMutate, isLoading: checkUserIsLoading } = useCheckUser();

  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  // handle input change
  const handleChange = (e: any) => {
    const inputValue = e.target.value;

    if (/^\d*$/.test(inputValue)) {
      const isValidFormat = /^07\d{8}$/.test(inputValue);
      setInputValid(isValidFormat);

      setPhoneNumber(e.target.value);
    }
  };
  // function to check user exists or not
  const handleCheckUser = () => {
    checkUserMutate(
      {
        mobile: phoneNumber,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          notify(successData?.message || 'OTP has been sent successfully', 'success');
          navigate('/auth/verify-otp', {
            state: { phoneNumber, ref: successData.serverRef, isNewUser: false },
          });
        },
        onError: ({ response: { data: errData } }: any) => {
          if (errData?.message === 'User not found!') {
            navigate('/auth/sign-up', { state: { phoneNumber } });
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  return (
    <div className="flex w-full h-full overflow-hidden relative">
      <div className="w-[55%] relative backdrop-welcome  justify-center items-center text-white hidden lg:flex flex-col gap-y-5">
        <div className="flex tracking-[20px] text-[3rem] font-light text-white text-shadow">
          WELCOME
        </div>

        <img src={welcomeImg} alt="welcome-img" className="w-[300px] h-[300px] z-[2]" />

        <div className="flex flex-col justify-center items-center z-[2]">
          <img src={dialogIcon} alt="dialog-icon" className="w-[100px]" />
          <div className="font-light text-xl text-white w-[70%] text-center">
            Welcome to the Dialog 3D 360 VR video platform
          </div>
        </div>
        <img src={circles} alt="welcome-img" className="w-[120px] absolute bottom-4 left-4 z-[1]" />
      </div>

      <div className="lg:rounded-l-[50px] lg:w-[50%] w-full border absolute h-full right-0 bg-[white] flex flex-col justify-center items-center">
        <div className="flex flex-col justify-center items-center relative h-full w-full">
          <div className="flex text-[50px] font-light text-[#F7941E] text-center justify-center items-center w-full">
            LOGIN
          </div>
          <div className="w-1/2 flex flex-col pt-5">
            <Input
              icon="ri-phone-line"
              placeholder="Phone"
              appearance="gray"
              value={phoneNumber}
              onChange={handleChange}
              onKeyPress={(e) => {
                if (e.key === 'Enter' && phoneNumber && phoneNumber.length === 10 && isInputValid) {
                  handleCheckUser();
                }
              }}
            />
          </div>

          <Button
            isRounded
            className="mt-5 !px-10"
            size="md"
            disabled={phoneNumber.length !== 10 || !isInputValid}
            isLoading={checkUserIsLoading}
            onClick={() => {
              if (phoneNumber) {
                handleCheckUser();
              }
            }}
          >
            Login
          </Button>

          <Button
            appearance="link"
            className="mt-1"
            onClick={() => {
              navigate('/auth/sign-up');
            }}
          >
            New User ?
          </Button>

          <div className="bottom-0 absolute flex w-full justify-center items-center pb-2 text-[10px]">
            <div className="underline">Terms & Conditions</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
